import React, { Component } from 'react';
import querystring from 'querystring';
import PropTypes from 'prop-types';
import Avatar from 'react-avatar';
import moment from 'moment';
import { defineMessages, FormattedMessage } from 'react-intl';
import truncate from 'html-truncate';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import s from './Header.scss';

import { sites, modules as modulesConfig } from '../../configPublic';
import {
  setRuntimeVariable,
  // alert as alertAction,
} from '../../actions/runtime';
import {
  RUNTIME_MOBILE_SIDEBAR_VISIBLE,
  // RUNTIME_LOADING_DATA,
  RUNTIME_MODAL,
} from '../../constants';

import Dropdown from '../Dropdown';
import Link from '../Link';
import Icon from '../Icon/Icon';
import Search from '../Search/Search';

const messages = defineMessages({
  global: {
    id: 'header.links.global',
    defaultMessage: 'Global',
    description: 'Global Link',
  },
  help: {
    id: 'header.links.help',
    defaultMessage: 'Help',
    description: 'Help Link',
  },
  myAccount: {
    id: 'header.links.myAccount',
    defaultMessage: 'My Account',
    description: 'My Account Link',
  },
  myWishlist: {
    id: 'header.links.myWishlist',
    defaultMessage: 'My Wishlist',
    description: 'My Wishlist Link',
  },
  logOut: {
    id: 'header.links.logOut',
    defaultMessage: 'Log Out',
    description: 'Log Out Link',
  },
  hello: {
    id: 'header.links.hello',
    defaultMessage: 'Hello',
    description: 'Hello Link',
  },
  logIn: {
    id: 'header.links.logIn',
    defaultMessage: 'Log In',
    description: 'Log In Link',
  },
  login: {
    id: 'header.links.login',
    defaultMessage: 'login',
    description: 'login Link',
  },
  register: {
    id: 'header.links.register',
    defaultMessage: 'register',
    description: 'register Link',
  },
  view: {
    id: 'header.links.view',
    defaultMessage: 'View',
    description: 'View Message Link',
  },
  viewAll: {
    id: 'header.links.viewAll',
    defaultMessage: 'View All Messages',
    description: 'View All Messages Link',
  },
});

class Header extends Component {
  static propTypes = {
    pointsBalance: PropTypes.number.isRequired,
    setMobileSidebarVisible: PropTypes.func.isRequired,
    isMobileSidebarVisible: PropTypes.bool.isRequired,
    title: PropTypes.arrayOf(
      PropTypes.shape({
        color: PropTypes.string,
        text: PropTypes.string,
      }),
    ),
    apps: PropTypes.arrayOf(PropTypes.string),
    locale: PropTypes.string.isRequired,
    isLoadingData: PropTypes.bool.isRequired,
    userData: PropTypes.shape({
      firstname: PropTypes.string,
    }),
    cartCount: PropTypes.number.isRequired,
    unreadMessages: PropTypes.object.isRequired //eslint-disable-line
  };

  static contextTypes = {
    routeParams: PropTypes.object.isRequired,
    url: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    query: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
  };

  static defaultProps = {
    userData: null,
    title: [],
    apps: [],
  };

  handleAsideToggleClick() {
    const { isMobileSidebarVisible, setMobileSidebarVisible } = this.props;
    setMobileSidebarVisible(!isMobileSidebarVisible);
  }

  getUserAvatar(user) {
    if (user && user.avatar && user.avatar.media && user.avatar.media._id) {
      return `https://staging.henkelbeautypro.com/ca/asset/${user.avatar.media._id}?width=125&height=125&type=fill`;
    }
    return null;
  }

  // getAppsIcon(app) {
  //   return {
  //     cmdctrl: "gear",
  //     etl: "arrowUpToLineSolid",
  //     filevault: "folder",
  //     poe: "",
  //     mytracker: "chartLineUp",
  //     messenger: "message",
  //     salondb: "scissors"
  //   }[app];
  // }

  render() {
    const {
      isLoadingData,
      apps,
      userData,
      isControl,
      isMobileSidebarVisible,
    } = this.props;
    const { url, intl, path, query, routeParams } = this.context;
    const { siteId } = routeParams;
    // const site = sites[siteId];
    const title = this.props.title.map(fragment => (
      <span key={fragment.text}>{fragment.text}</span>
    ));

    const avatarSrc = this.getUserAvatar(userData);

    // routeParams: PropTypes.object.isRequired,
    // url: PropTypes.object.isRequired,
    // intl: PropTypes.object.isRequired,
    // query: PropTypes.object.isRequired,
    // path: PropTypes.string.isRequired

    // const modules =
    //   apps.length > 0 &&
    //   apps
    //     .filter(app => app !== "clubskp")
    //     .concat(["clubskp"])
    //     .map(app => {
    //       let routeName;
    //       let query;
    //       let routeParams;
    //       modulesConfig.forEach(mod => {
    //         if (mod.value === app) {
    //           query = mod.query || "";
    //           routeName =
    //             typeof mod.route === "function"
    //               ? mod.route(userData)
    //               : mod.route;
    //           routeParams = mod.routeParams || {};
    //         }
    //       });

    //       if (
    //         app === "printcenter" ||
    //         app === "advisornet" ||
    //         app === "clubskp"
    //       ) {
    //         return;
    //       }

    //       return (
    //         <li key={app}>
    //           <Link
    //             className="Header__appsLink"
    //             to={`${url.getUrl(
    //               routeName,
    //               Object.assign({ siteId }, routeParams)
    //             )}${query}`}
    //           >
    //             <div className="Header__appsIcon">
    //               <Icon icon={this.getAppsIcon(app)} />
    //             </div>
    //             {/* <img src={`/assets/img/app-${app}.svg`} alt="" /> */}
    //             <div className="Header__appsLabel">{app}</div>
    //           </Link>
    //         </li>
    //       );
    //     });

    // const siteLocales = site.localesIntl(intl);
    // const localeIds = Object.keys(siteLocales);
    // const activeLocale = this.props.locale;
    // const dropdownLinks = [];

    // if (localeIds.length > 1) {
    //   for (const localeId in siteLocales) {
    //     const activeClass = activeLocale === localeId ? " active" : "";
    //     dropdownLinks.push(
    //       <li key={`lang${localeId}`}>
    //         <a
    //           className={`dropdown-menu__link${activeClass}`}
    //           href={`/${siteId}/language/${localeId}`}
    //         >
    //           {siteLocales[localeId].label}
    //         </a>
    //       </li>
    //     );
    //   }
    // }

    // dropdownLinks.push(
    //   <li key="global">
    //     <Link className="dropdown-menu__link" to="/global">
    //       <FormattedMessage {...messages.global} />
    //     </Link>
    //   </li>
    // );
    // dropdownLinks.push(
    //   <li key="help">
    //     <a
    //       className="dropdown-menu__link"
    //       href={sites[siteId].contact.support}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       <FormattedMessage {...messages.help} />
    //     </a>
    //   </li>
    // );

    // if (userData) {
    //   dropdownLinks.unshift(
    //     <li key="myaccount">
    //       <Link
    //         className="dropdown-menu__link"
    //         to={url.getUrl("account", { siteId })}
    //       >
    //         <FormattedMessage {...messages.myAccount} />
    //       </Link>
    //     </li>,
    //     <li key="mywishlist">
    //       <Link
    //         className="dropdown-menu__link"
    //         to={url.getUrl("cart-wishlist", { siteId })}
    //       >
    //         <FormattedMessage {...messages.myWishlist} />
    //       </Link>
    //     </li>
    //   );
    //   dropdownLinks.push(
    //     <li key="logout">
    //       <a className="dropdown-menu__link" href={`/${siteId}/logout`}>
    //         <FormattedMessage {...messages.logOut} />
    //       </a>
    //     </li>
    //   );
    // } else {
    //   dropdownLinks.unshift(
    //     <li key="login">
    //       <Link
    //         className="dropdown-menu__link"
    //         to={`${url.getUrl("auth-index", {
    //           siteId
    //         })}?redirect=${encodeURIComponent(
    //           `${path}?${querystring.stringify(query)}`
    //         )}`}
    //       >
    //         <FormattedMessage {...messages.logIn} />
    //       </Link>
    //     </li>
    //   );
    // }

    // const messagesDropdown = (this.props.unreadMessages.docs || []).map(msg => {
    //   const fromAvatarMediaId = (
    //     (((msg.from || {}).user || {}).avatar || {}).media || {}
    //   )._id;
    //   const fromAvatarSrc = fromAvatarMediaId
    //     ? `/${siteId}/asset/${fromAvatarMediaId}?width=125&height=125&type=fill`
    //     : null;
    //   const fromName = `${msg.from.user.firstname} ${msg.from.user.lastname}`;

    //   return (
    //     <div className="Header__notify flex" key={msg._id}>
    //       <div className="Header__notifyAvatar">
    //         <Avatar
    //           className="img"
    //           size={43}
    //           round
    //           src={fromAvatarSrc}
    //           // color={colors[Math.floor(Math.random() * colors.length)]}
    //           name={fromName}
    //         />
    //       </div>
    //       <div>
    //         <div className="Header__notifyTxt">{moment(msg.dc).calendar()}</div>
    //         <div className="Header__notifyName">{fromName}</div>
    //         <div className="Header__notifyTxt">
    //           <span className="Header__notifyMsg">
    //             {truncate(msg.subject, 30)}
    //           </span>
    //           <Link className="Header__notifyLink" to={`/${siteId}/messenger`}>
    //             <FormattedMessage {...messages.view} />
    //           </Link>
    //         </div>
    //       </div>
    //     </div>
    //   );
    // });

    return (
      <div className="Header">
        <button
          className="Header__asideButton"
          type="button"
          onClick={() => this.handleAsideToggleClick()}
        >
          {isMobileSidebarVisible ? (
            <Icon icon="xmark" />
          ) : (
            <Icon icon="bars" />
          )}
        </button>

        <div className="Header__moduleNameContainer">
          <div
            className={cx('Header__moduleName', { '--isControl': isControl })}
          >
            {title}
          </div>
        </div>

        {/* {apps.length > 0 && (
          <Dropdown
            dropClassName="--isShow"
            mouseOutHandler
            mouseOverHandler={false}
          >
            <div className="Header__navActionContainer">
              <Icon icon="grid" style={{ fontSize: 24 }} />
            </div>

            <div className="Header__dropdown --apps">
              <ul className="Header__appsList">{modules}</ul>
            </div>
          </Dropdown>
        )} */}

        {/* {isLoadingData ? (
          <i className={`${s.topNavIcons} isShow`} />
        ) : (
          <i className={s.topNavIcons} />
        )} */}

        <div className="Header__searchContainer">
          <Search siteId={siteId} />
        </div>

        <ul className="Header__nav">
          {/* {userData && apps.includes("messenger") && (
            <li className="Header__navItem --messenger">
              <Dropdown
                dropClassName="--isShow"
                mouseOutHandler
                mouseOverHandler={false}
                style={{ width: "100%", height: "100%" }}
              >
                <div className="Header__navActionContainer">
                  <Icon icon="message" style={{ fontSize: 24 }} />

                  {this.props.unreadMessages.total > 0 && (
                    <div className="Header__notificationBadge">
                      {this.props.unreadMessages.total}
                    </div>
                  )}
                </div>

                <div className="Header__dropdown --messenger">
                  {messagesDropdown.length > 0 ? (
                    messagesDropdown
                  ) : (
                    <div className="Header__notify">No unread messages.</div>
                  )}

                  <Link
                    className="Header__notifyAll text-center"
                    to={`/${siteId}/messenger`}
                  >
                    <FormattedMessage {...messages.viewAll} />
                  </Link>
                </div>
              </Dropdown>
            </li>
          )} */}

          {userData ? (
            <li className="Header__navItem">
              <Dropdown
                dropClassName="--isShow"
                mouseOutHandler
                mouseOverHandler={false}
                style={{ width: '100%', height: '100%' }}
              >
                <div className="Header__navActionContainer">
                  {avatarSrc ? (
                    <img className="Header__avatarContainer" src={avatarSrc} />
                  ) : (
                    <Icon
                      icon="user"
                      style={{ marginRight: 5, fontSize: 24 }}
                    />
                  )}
                  <span className="Header__username">
                    {userData.firstname}{' '}
                  </span>
                  {this.props.pointsBalance > 0 && (
                    <span className="Header__points">
                      ({this.props.pointsBalance} Points)
                    </span>
                  )}
                </div>

                <div className="Header__dropdown --user">
                  <Link
                    className="Header__dropdownLink"
                    to={url.getUrl('account', { siteId })}
                  >
                    <Icon icon="user" />
                    <span>
                      <FormattedMessage {...messages.myAccount} />
                    </span>
                  </Link>
                  <a
                    className="Header__dropdownLink"
                    href={`/${siteId}/logout?redirect=true`}
                  >
                    <Icon icon="arrowRightFromBracket" />
                    <span>
                      <FormattedMessage {...messages.logOut} />
                    </span>
                  </a>
                </div>
              </Dropdown>
            </li>
          ) : (
            <li className="Header__navItem">
              <Link
                className="Header__loginLink"
                to={`${url.getUrl('auth-index', {
                  siteId,
                })}?redirect=${encodeURIComponent(
                  `${path}?${querystring.stringify(query)}`,
                )}`}
              >
                <FormattedMessage {...messages.login} />
              </Link>
              <span> / </span>
              <Link
                className="Header__loginLink"
                to={url.getUrl('auth-register', { siteId })}
              >
                <FormattedMessage {...messages.register} />
              </Link>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const session = state.session;
  // console.info('session', session);
  const runtime = state.runtime;
  // let cartCount = 0;
  // (session.CART || []).forEach(item => {
  //   cartCount += item.qty;
  // });
  const cartCount = (session.CART || []).length;

  return {
    locale: session.LOCALE,
    pointsBalance: session.POINTS_BALANCE || 0,
    apps: ((session.USER_DATA || {}).group || {}).modules,
    userData: session.USER_DATA,
    isMobileSidebarVisible: runtime.RUNTIME_MOBILE_SIDEBAR_VISIBLE || false,
    isLoadingData: runtime.RUNTIME_LOADING_DATA || false,
    cartCount,
    unreadMessages: session.UNREADMESSAGES || {},
  };
};

const mapDispatchToProps = dispatch => ({
  setMobileSidebarVisible: visible => {
    dispatch(
      setRuntimeVariable({
        name: RUNTIME_MOBILE_SIDEBAR_VISIBLE,
        value: visible,
      }),
    );
    if (visible) {
      dispatch(
        setRuntimeVariable({
          name: RUNTIME_MODAL,
          value: {
            type: 'aside',
            payload: {
              onClose: () => {
                dispatch(
                  setRuntimeVariable({
                    name: RUNTIME_MOBILE_SIDEBAR_VISIBLE,
                    value: false,
                  }),
                );
              },
            },
          },
        }),
      );
    }
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(s)(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js